import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_CELL_TAPPED_SCHEMA = Object.freeze({
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_CELL_TAPPED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CELL_TAPPED_SCHEMA);

export class CellTappedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.cell_tapped;
  }

  get properties() {
    return this.toJS();
  }
}
